<template lang="pug">
div
  .icon-text.is--success(v-if="success")
    svg(fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg')
      path(d='M11.25 16.75H12.75V11H11.25V16.75ZM12 9.28845C12.2288 9.28845 12.4207 9.21105 12.5755 9.05625C12.7303 8.90145 12.8077 8.70963 12.8077 8.48078C12.8077 8.25194 12.7303 8.06012 12.5755 7.9053C12.4207 7.7505 12.2288 7.6731 12 7.6731C11.7711 7.6731 11.5793 7.7505 11.4245 7.9053C11.2697 8.06012 11.1923 8.25194 11.1923 8.48078C11.1923 8.70963 11.2697 8.90145 11.4245 9.05625C11.5793 9.21105 11.7711 9.28845 12 9.28845ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C9.76664 3.99998 7.87498 4.77498 6.32498 6.32498C4.77498 7.87498 3.99998 9.76664 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20Z')
    .icon-text-content
      p(v-html="i18n.success_msg")
  .multistep(v-else)
    .steps
      span.step(:class="activeStepClass(1)") 1
        span.label {{i18n.step1}}
      span.step(:class="activeStepClass(2)") 2
        span.label {{i18n.step2}}
      span.step(:class="activeStepClass(3)") 3
        span.label {{i18n.step3}}
    .multistep-tab(:class="activeTabClass(1)"): step1(v-model:buttonDisabled="buttonDisabled" v-model:form="form" :settings="settings" :i18n="i18n" :step="step" :packages="packages" :countries="countries")
    .multistep-tab(:class="activeTabClass(2)"): step2(v-model:buttonDisabled="buttonDisabled" v-model:form="form" :settings="settings" :i18n="i18n" :step="step" :packages="packages" :countries="countries")
    .multistep-tab(:class="activeTabClass(3)"): step3(v-model:buttonDisabled="buttonDisabled" v-model:form="form" :settings="settings" :i18n="i18n" :step="step" :packages="packages" :countries="countries")
    .navigation
      button#prev-btn.btn.is--inverted.is--secondary(type='button' @click="prevStep" v-if="step != 1")
        span {{i18n.prev}}
      button#next-btn.btn.is--inverted(type='button' @click="nextStep" :class="buttonDisabled ? 'is--disabled' : ''")
        span(v-if="step != 3") {{i18n.next}}
        span(v-else) {{i18n.submit}}
</template>

<script>
import Step1 from './Steps/Step1.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'

export default {
  components: {Step1, Step2, Step3},
  props: [
    "i18n",
    "settings",
    "html",
  ],
  data () {
    return {
      form: {
      },
      buttonDisabled: true,
      step: 1,
      success: false,
      packages: [],
      countries: []
    }
  },
  mounted () {
    const _params = Object.fromEntries(new URLSearchParams(location.search));

    this.form.salutation = "male"
    this.form.country = "DE"
    this.form.package = _params.package || "Bestseller"
    this.lang = this.settings.lang || "cs"

    const csrfToken = document.getElementsByName("csrf-token")[0].content
    const params = {
      lang: this.lang
    }
    const options = {
      method: "POST",
      body: JSON.stringify(params),
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
        "Accept": "application/json",
      }
    }

    fetch("/api/travel/_config", options).then(r => r.json() ).then( data => {
      this.countries = data.countries
      this.packages = data.packages
      if (data.countries.find(x => x.id == this.lang.toUpperCase())){
        this.form.country = this.lang.toUpperCase()
      }
    })
  },
  watch: {
  },
  computed: {
  },
  methods: {
    prevStep(){
      // if (this.buttonDisabled) return false
      document.getElementById('travelForm').scrollIntoView();
      this.buttonDisabled = false
      this.step--
    },
    nextStep(){
      if (this.step == 3) {
        const csrfToken = document.getElementsByName("csrf-token")[0].content
        const params = {
          travel_form: this.form
        }
        const options = {
          method: "POST",
          body: JSON.stringify(params),
          headers: {
            "X-CSRF-Token": csrfToken,
            "Content-Type": "application/json",
            "Accept": "application/json",
          }
        }
        fetch("/api/travel", options)
        this.success = true
      } else {
        if (this.buttonDisabled) return false
        document.getElementById('travelForm').scrollIntoView();
        this.buttonDisabled = true
        this.form._update = !this.form._update
        this.step++
      }
    },
    activeTabClass(i){
      if(i != this.step) return "is--hidden"
    },
    activeStepClass(i){
      if(i === this.step) return "is--active"
      if(i < this.step) return "is--finished"
    }
  }
}
</script>
